import '@hapana/shared/utils/type-defs.util'

/** @type {Styles} */
export const styles = {
  dialogContent: { padding: 0, position: 'relative', overflowY: 'auto' },
  content: { paddingY: 2.5, paddingX: 4 },
  groupContainer: { paddingTop: 2 },
  groupHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  list: { display: 'flex', flexDirection: 'column' },
  listItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingY: 3,
    '&:first-child': { paddingTop: 2 },
    '&:not(:first-child)': { borderTop: '1px solid', borderColor: 'gray.12' },
  },
  personInfo: { display: 'flex', alignItems: 'center', gap: 2 },
  personDetails: { display: 'flex', flexDirection: 'column', gap: 0.5 },
  actions: { display: 'flex', alignItems: 'center', gap: 1.5 },
  divider: { marginX: -3, marginBottom: 2 },
  filterButtonRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  loadingContainer: { mt: 2 },
  topMargin: { mt: 2 },
  badgePosition: { '.MuiBadge-badge': { top: 6, right: 6 } },
  email: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: 130,
  },
}
